module.exports = __webpack_public_path__ + "img/Safari_Diner_logo.ddf24a12.png";